import { useAppointmentCheckinMutation } from "../../../../../../../api/appointments/useAppointmentCheckinMutation";
import { useAppointmentCheckinQuery } from "../../../../../../../api/appointments/useAppointmentCheckinQuery";
import { uiNotification } from "../../../../../../../services/UINotificationService";
import { useContext } from "../context";

export function useCheckin() {
  const { appointment, refetchAppointments } = useContext();

  const { data, isLoading } = useAppointmentCheckinQuery(
    {
      appointmentId: appointment.id,
    },
    {
      onError: () => {
        uiNotification.error(
          "Unable to fetch check-in data for this appointment. Try again later.",
        );
      },
      onSuccess: () => {
        refetchAppointments();
      },
    },
  );

  const { mutateAsync, isLoading: isCheckingIn } =
    useAppointmentCheckinMutation({
      onError: () => {
        uiNotification.error(
          "Unable to check-in for this appointment. Try again later.",
        );
      },
    });

  return {
    data,
    isLoading,
    initiate: ({ room, notes, customerNewNote, sendToProvider }) => {
      return mutateAsync({
        appointmentId: appointment.id,
        room,
        notes,
        customerNewNote,
        sendToProvider,
      });
    },
    isCheckingIn,
  };
}
